import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import {Options} from 'highcharts';
import {InsightsService} from "../../services/insights/insights.service";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {TrendChartService} from "../../services/trend-chart/trend-chart.service";
import moment from "moment";

@Component({
  selector: 'app-participation-trend',
  templateUrl: './participation-trend.component.pug',
  styleUrls: ['./participation-trend.component.scss'],
  standalone: false
})
export class ParticipationTrendComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() questionnaire!: any;
  @Input() filterBy!: any;
  @Input() state!: string;
  updateFlag = false;

  colorMap: Map<string, any> =
    new Map([
      ['participated', {
        'color': '#DE8C02',
        'backgroundColor': 'rgba(222,140,2,0.05)',
        'stop_0_color': 'rgb(222, 163, 2)',
        'stop_1_color': 'rgb(255, 255, 255)'
      }],
      ['optedIn', {
        'color': '#32735F',
        'backgroundColor': 'rgba(50,115,95,0.05)',
        'stop_0_color': 'rgb(50,115,95)',
        'stop_1_color': 'rgb(255, 255, 255)'
      }],
      ['submitted', {
        'color': '#32735F',
        'backgroundColor': 'rgba(50,115,95,0.05)',
        'stop_0_color': 'rgb(50,115,95)',
        'stop_1_color': 'rgb(255, 255, 255)'
      }],
      ['declined', {
        'color': '#AF0001',
        'backgroundColor': 'rgba(175,0,1,0.05)',
        'stop_0_color': 'rgb(173, 75, 75)',
        'stop_1_color': 'rgb(255, 255, 255)'
      }],
      ['unresponsive', {
        'color': '#000000',
        'backgroundColor': 'rgba(0,0,0,0.05)',
        'stop_0_color': 'rgb(84, 83, 83)',
        'stop_1_color': 'rgb(255, 255, 255)'
      }]
    ]);

  dateFormat = new Map([
    ["dates", "YYYY-MM-DD"],
    ["weeks", "YYYY_W"],
    ["months", "YYYY_MM"],
    ["quarters", "YYYY_Q"],
    ["years", "YYYY"],
  ]);

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Options = TrendChartService.getOptions([], 0, 100, 360, 800, '', '', '', '', '');

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService,) {
  }

  ngOnInit(): void {
  }

  loadData(): void {
    let options = this.colorMap.get(this.state);
    this.insightsService.getParticipationTrend(this.start, this.end, this.questionnaire, this.filterBy, this.state, 'exit').subscribe(data => {
      let result_type = this.dateFormat.get(data['result_type']);
      let series: any = [];
      for (let d of data["result"]) {
        series.push([moment.utc(d['date'], result_type).toDate().getTime(), d['participation']]);
      }
      TrendChartService.setChartOptionsFromData(this.chartOptions, series, result_type, options.backgroundColor, options.stop_0_color, options.stop_1_color, options.color);
      this.updateFlag = true;
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      TrendChartService.setChartOptionsFromData(this.chartOptions, [], 'quarters');
      this.updateFlag = true;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadData();
  }
}
